module.exports = __webpack_public_path__ + "img/sup_iniciacion.ca26647b.jpg";